/* JRS landing — interaction JS (deferred).
   Two-step form (validate/step-nav/submit/success) + sticky-CTA hide-on-form.
   NOTE: the hero's dynamic-headline swap is a separate INLINE script in jrs-ta-hero.liquid
   (must run synchronously before first paint); do not move it here. */
(function () {
  "use strict";
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  function digits(s){ return (s||"").replace(/\D/g,""); }
  function captureParams(){
    var p = {};
    try { var q = new URLSearchParams(location.search);
      ["fbclid","utm_source","utm_medium","utm_campaign","utm_content","utm_term"].forEach(function(k){ var v=q.get(k); if(v) p[k]=v; });
    } catch(e){}
    return p;
  }

  /* Read a cookie value (e.g. Meta Pixel's _fbp / _fbc). Returns "" if absent or on error. */
  function getCookie(name){
    try {
      var m = document.cookie.match("(?:^|; )" + name.replace(/([.$?*|{}()\[\]\\\/+^])/g, "\\$1") + "=([^;]*)");
      return m ? decodeURIComponent(m[1]) : "";
    } catch(e){ return ""; }
  }

  /* lead_event_id — crypto.randomUUID() when available (secure contexts), else a UUIDv4
     built from crypto.getRandomValues() so HTTP dev-preview URLs (no randomUUID) still work. */
  function genEventId(){
    try {
      if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
      if (window.crypto && crypto.getRandomValues){
        var b = new Uint8Array(16); crypto.getRandomValues(b);
        b[6] = (b[6] & 0x0f) | 0x40;            // version 4
        b[8] = (b[8] & 0x3f) | 0x80;            // variant
        var h = []; for (var i = 0; i < 256; i++){ h[i] = (i + 0x100).toString(16).slice(1); }
        return h[b[0]]+h[b[1]]+h[b[2]]+h[b[3]]+"-"+h[b[4]]+h[b[5]]+"-"+h[b[6]]+h[b[7]]+"-"+
               h[b[8]]+h[b[9]]+"-"+h[b[10]]+h[b[11]]+h[b[12]]+h[b[13]]+h[b[14]]+h[b[15]];
      }
    } catch(e){}
    return "lead-" + Date.now() + "-" + Math.floor(Math.random() * 1e9).toString(16);  // last-resort, never crashes
  }
  function setErr(fld,on){
    fld.classList.toggle("is-invalid",!!on);
    var e=fld.querySelector("[data-err]"); if(e) e.hidden=!on;
    var i=fld.querySelector("input"); if(i) i.setAttribute("aria-invalid",on?"true":"false");
  }

  /* Tracklution "Lead" — fires ONCE, only from the form's success callback (see done()).
     Guarded so a missing script is a silent no-op. tracklution() is injected site-wide via
     GTM / app-embed (carried onto this page by content_for_header), not by the theme. */
  function fireLead(d){
    if(window.__jrsLeadFired || typeof tracklution !== "function") return;
    window.__jrsLeadFired = true;                 // page-session dedupe (covers both form placements)
    var name=(d.name||"").trim(), sp=name.indexOf(" ");
    var first = sp === -1 ? name : name.slice(0, sp);
    var last  = sp === -1 ? "" : name.slice(sp+1).trim();
    try {
      tracklution("event","Lead",{
        value:100, currency:"GBP",
        email:d.email||"", phone:d.phone||"",
        first_name:first, last_name:last         // single "name" field split on first space
      });
    } catch(e){}
  }

  function initForm(form){
    var params = captureParams();
    var angle = window.__jrsAngle || "admin";
    var renderedAt = Date.now(), MIN_FILL_MS = 3000;   // honeypot time-trap baseline (see submit handler)
    var aEl = form.querySelector('[name="angle"]'); if(aEl) aEl.value = angle;
    Object.keys(params).forEach(function(k){ var el=form.querySelector('[name="'+k+'"]'); if(el) el.value=params[k]; });

    var step1=form.querySelector('[data-step="1"]'), step2=form.querySelector('[data-step="2"]'),
        success=form.querySelector('[data-success]'), label=form.querySelector('[data-step-label]'),
        bar=form.querySelector('[data-progress]'), nextBtn=form.querySelector('[data-next]'),
        backBtn=form.querySelector('[data-back]'), submitBtn=form.querySelector('[data-submit]'),
        formErr=form.querySelector('[data-formerr]');

    function show(n,doFocus){
      step1.hidden=n!==1; step2.hidden=n!==2;
      if(label) label.textContent="Step "+n+" of 2";
      if(bar) bar.style.width=(n===1?50:100)+"%";
      /* Only focus on user-driven step changes — focusing on initial render scrolls
         the page to whichever form is lower (both forms init), the auto-scroll bug. */
      if(doFocus){ var f=(n===1?step1:step2).querySelector("input:not([type=hidden])"); if(f) f.focus(); }
    }
    function v1(){
      var ok=true, c=form.querySelector('[name="company"]').closest(".fld");
      if(!c.querySelector("input").value.trim()){setErr(c,true);ok=false;}else setErr(c,false);
      ["staff_band","spend_band"].forEach(function(n){
        var fs=form.querySelector('[name="'+n+'"]').closest(".fld");
        if(!fs.querySelector("input:checked")){setErr(fs,true);ok=false;}else setErr(fs,false);
      });
      return ok;
    }
    function v2(){
      var ok=true,
          nf=form.querySelector('[name="name"]').closest(".fld"),
          ef=form.querySelector('[name="email"]').closest(".fld"),
          pf=form.querySelector('[name="phone"]').closest(".fld");
      if(!nf.querySelector("input").value.trim()){setErr(nf,true);ok=false;}else setErr(nf,false);
      if(!EMAIL.test(ef.querySelector("input").value.trim())){setErr(ef,true);ok=false;}else setErr(ef,false);
      if(digits(pf.querySelector("input").value).length<7){setErr(pf,true);ok=false;}else setErr(pf,false);
      return ok;
    }
    nextBtn.addEventListener("click",function(){ if(v1()) show(2,true); });
    if(backBtn) backBtn.addEventListener("click",function(){ show(1,true); });
    ["input","change"].forEach(function(ev){ form.addEventListener(ev,function(e){
      var f=e.target.closest(".fld"); if(f&&f.classList.contains("is-invalid")) setErr(f,false);
    });});

    /* Webhook POST body — EXACTLY the 18 keys Make is mapped to (Doc: lead-form contract).
       staff_band → team_size_band here (body key only; the radio name, validator, and the
       dataLayer push below keep staff_band). page_url / form_location / submitted_at / fbclid
       are intentionally NOT sent (Make derives IP + timestamp; fbclid only feeds fbc). */
    function payload(){
      var g=function(n){ var el=form.querySelector('[name="'+n+'"]'); return el?el.value:""; };
      // fbc: prefer the real _fbc cookie; if absent but a real fbclid is in the URL, build the
      // standard fb.1.<ts>.<fbclid> form; otherwise "" (never fabricate an fbclid).
      var fbc = getCookie("_fbc");
      if(!fbc){ var fbclid = g("fbclid"); fbc = fbclid ? ("fb.1." + Date.now() + "." + fbclid) : ""; }
      return {
        company:g("company").trim(),
        team_size_band:(form.querySelector('[name="staff_band"]:checked')||{}).value||"",
        spend_band:(form.querySelector('[name="spend_band"]:checked')||{}).value||"",
        name:g("name").trim(), email:g("email").trim(), phone:g("phone").trim(),
        consent:true, marketing_opt_in:false,                          // implied-consent model (no checkbox UI)
        lead_event_id:genEventId(),
        fbp:getCookie("_fbp")||"",
        fbc:fbc,
        client_user_agent:(navigator.userAgent||""),
        utm_source:g("utm_source"), utm_medium:g("utm_medium"), utm_campaign:g("utm_campaign"),
        utm_content:g("utm_content"), utm_term:g("utm_term"),
        angle:angle
      };
    }
    /* dataLayer push — UNCHANGED output: same event name, same keys (incl. staff_band), same
       values. Reads from the DOM/closure now (not the payload) because the body renamed that
       key to team_size_band; this keeps jrs_lead_submit's contract identical. */
    function pushLead(){
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push({event:"jrs_lead_submit",angle:angle,
        staff_band:(form.querySelector('[name="staff_band"]:checked')||{}).value||"",
        spend_band:(form.querySelector('[name="spend_band"]:checked')||{}).value||"",
        form_location:form.getAttribute("data-location")||""});
    }

    form.addEventListener("submit",function(e){
      e.preventDefault();
      // Honeypot + time-trap. The hidden hp_field is readonly + data-1p-ignore/data-lpignore, so
      // password managers / browser autofill skip it. As a belt-and-braces against any autofill that
      // still slips through (which previously fired on real users), we only treat it as spam when it's
      // filled AND the form was submitted implausibly fast: a real 2-step human submit always takes
      // longer than MIN_FILL_MS, while a bot that fills everything and fires instantly is caught.
      // Silent abort — no POST, no error shown (don't tip the bot off). hp_field is never in the body.
      var hp=form.querySelector('[name="hp_field"]');
      if(hp && hp.value.trim() && (Date.now() - renderedAt) < MIN_FILL_MS){ return; }
      if(!v2()) return;
      if(submitBtn.disabled) return;                 // guard against double/rapid submit
      var endpoint=form.getAttribute("data-endpoint"), data=payload();
      submitBtn.disabled=true; submitBtn.textContent="Sending…"; if(formErr) formErr.hidden=true;
      var done=function(){ fireLead(data); pushLead(); step2.hidden=true; success.hidden=false; success.focus(); };
      var fail=function(err){ submitBtn.disabled=false; submitBtn.textContent="Get portal access";
        if(formErr){ formErr.hidden=false; formErr.textContent="Something went wrong. Please call 01698 534414 or try again."; }
        /* Instrumentation (2026-09-03) */
        try{ if((window.JRS && JRS.ErrorTelemetry && typeof JRS.ErrorTelemetry.report === 'function')){ JRS.ErrorTelemetry.report('trade_account','trade_account_submit_failed',{ message:"Something went wrong. Please call 01698 534414 or try again.", detail:String((err&&err.message)||'network'), http_status:0 }); } }catch(e2){} };
      if(!endpoint){ console.warn("[jrs-form] no endpoint set"); done(); return; }  // lets you preview the success state with no endpoint
      /* CORS: the Make webhook is cross-origin and returns no Access-Control-Allow-Origin, so
         its response is opaque. A text/plain POST is a CORS "simple request" (no preflight), so
         Make DOES receive + process it (Sheet row + emails fire server-side). We use mode:'no-cors'
         and treat the promise RESOLVING as success — we cannot read status (it's 0/opaque), so the
         success state and the Tracklution/dataLayer fire key off resolution, NOT a verified 200.
         .catch(fail) only triggers on a genuine network error (offline/DNS), where the input is
         preserved and the button re-enabled for retry. */
      fetch(endpoint,{method:"POST",mode:"no-cors",headers:{"Content-Type":"text/plain;charset=UTF-8"},body:JSON.stringify(data),keepalive:true})
        .then(done).catch(fail);
    });
    show(1,false);   /* initial render — no focus (prevents auto-scroll on load) */
  }

  function initSticky(){
    var sticky=document.querySelector(".sticky");
    if(!sticky || !("IntersectionObserver" in window)) return;
    var cards=document.querySelectorAll(".formcard"); if(!cards.length) return;
    var vis=new Set();
    var io=new IntersectionObserver(function(es){
      es.forEach(function(en){ en.isIntersecting?vis.add(en.target):vis.delete(en.target); });
      sticky.classList.toggle("hide",vis.size>0);
    },{threshold:0.2});
    cards.forEach(function(c){ io.observe(c); });
  }

  /* ---- Elevated motion (below-fold reveal, hero underline, count-ups) ----
     Separate from + never touching the hero's ?angle= first-paint inline script.
     Above-the-fold hero content is never .reveal (so it paints regardless of JS).
     Reveal-hide is keyed off html.jrs-anim, which THIS function adds — so if the motion
     JS never runs (error / blocked), .reveal content stays visible (never stuck hidden). */
  function initMotion(){
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion:reduce)").matches;
    if(!reduce){ document.documentElement.classList.add("jrs-anim"); }   /* enables the reveal-hide CSS */

    var hero = document.getElementById("top");
    if(hero){ requestAnimationFrame(function(){ hero.classList.add("is-in"); }); }  /* decorative underline only */

    function activate(el){
      el.classList.add("is-in");
      var hinge = el.querySelector ? el.querySelector(".hinge") : null;
      if(hinge) hinge.classList.add("lit");
    }
    var targets = Array.prototype.slice.call(document.querySelectorAll(".reveal, .portal-stage"));
    if(reduce || !("IntersectionObserver" in window)){
      targets.forEach(activate);
    } else {
      var io = new IntersectionObserver(function(entries, obs){
        entries.forEach(function(e){
          if(!e.isIntersecting) return;
          var t = e.target;
          if(t.classList.contains("reveal")){
            var parent = t.parentElement;
            var sibs = parent ? Array.prototype.slice.call(parent.querySelectorAll(":scope > .reveal")) : [t];
            t.style.transitionDelay = (Math.max(0, sibs.indexOf(t)) * 80) + "ms";
          }
          activate(t); obs.unobserve(t);
        });
      }, { threshold:0, rootMargin:"0px 0px -8% 0px" });   /* threshold 0 = fires for any element size */
      targets.forEach(function(el){ io.observe(el); });
    }

    /* count-up — SSR already holds the final value (correct with no JS / reduced-motion); animates once in view. */
    document.querySelectorAll(".countup").forEach(function(el){
      var target = parseFloat(el.getAttribute("data-target")) || 0;
      var dec = parseInt(el.getAttribute("data-decimals"), 10) || 0;
      if(reduce || !("IntersectionObserver" in window)){ el.textContent = target.toFixed(dec); return; }
      var done = false;
      new IntersectionObserver(function(entries, obs){
        entries.forEach(function(e){
          if(!e.isIntersecting || done) return;
          done = true; obs.disconnect();
          var start = null, dur = 900;
          function tick(ts){
            if(start === null) start = ts;
            var p = Math.min(1, (ts - start) / dur);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = (target * eased).toFixed(dec);
            if(p < 1){ requestAnimationFrame(tick); } else { el.textContent = target.toFixed(dec); }
          }
          requestAnimationFrame(tick);
        });
      }, { threshold:.6 }).observe(el);
    });
  }

  /* UGC video — facade: the file never downloads on view; tapping injects the <video>
     (autoplay+controls+playsinline, user-gesture so sound is allowed) and plays it. */
  function initVideos(){
    document.querySelectorAll(".video.has-video[data-video-src]").forEach(function(box){
      box.addEventListener("click", function(){
        if(box.querySelector("video.video-el")) return;     // already loaded
        var src = box.getAttribute("data-video-src"); if(!src) return;
        var v = document.createElement("video");
        v.className = "video-el";
        v.src = src;
        v.controls = true; v.autoplay = true; v.playsInline = true; v.preload = "auto";
        v.setAttribute("playsinline", "");                  // iOS inline (no fullscreen takeover)
        box.classList.add("is-playing");
        box.appendChild(v);
        var pr = v.play(); if(pr && pr.catch){ pr.catch(function(){}); }
      });
    });
  }

  document.addEventListener("DOMContentLoaded",function(){
    /* Motion first + isolated: a form/sticky error must never leave .reveal content hidden. */
    try{ initMotion(); }catch(e){ document.documentElement.classList.remove("jrs-anim"); }
    document.querySelectorAll(".jrs-form").forEach(function(f){ try{ initForm(f); }catch(e){} });
    try{ initSticky(); }catch(e){}
    try{ initVideos(); }catch(e){}
  });
})();
